import React, { Fragment, useState, useEffect } from "react";
import Heading from "./Heading";
import ProductSellingItem from "./ProductSellingItem";
import APIService from "../services/APIService";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import { Autoplay } from "swiper";
// Import Swiper styles

export default function SellingProducts() {
  const [swiper, setSwiper] = useState(null);
  const [swiperM, setSwiperM] = useState(null);
  const [productsSelling, setProductsSelling] = useState(["", "", "", "", ""]);

  async function getProductSelling() {
    const RESULT = await APIService.getProductSelling(1, 5);
    if (RESULT) {
      setProductsSelling(RESULT.data);
    }
  }

  useEffect(() => {
    getProductSelling();
  }, []);

  const handleNext = () => {
    console.log("next");
    swiper.slideNext();
    swiperM.slideNext();
  };
  const handlePrev = () => {
    swiper.slidePrev();
    swiperM.slidePrev();
  };

  return productsSelling.length ? (
    <Fragment>
     
      <Swiper
        // modules={[Autoplay]}
        breakpoints={{
          320: {
            width: 320,
            slidesPerView: 1.5,
          },
          640: {
            width: 640,
            slidesPerView: 1.75,
          },
          769: {
            width: 769,
            slidesPerView: 2.1,
          },
          1024: {
            width: 1024,
            slidesPerView: 2.8,
          },
          1280: {
            width: 1280,
            slidesPerView: 3.5,
          },
        }}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        // style={{paddingVertical: 10}}
        className="mySwiper"
        pagination={{ clickable: true }}
        scrollbar={{ draggable: true }}
        onSwiper={setSwiper}
      >
         <Heading
                 slot="container-start"
        title="Sản phẩm bán chạy"
        handlePrev={handlePrev}
        handleNext={handleNext}
      />
        {productsSelling.map((item, index) => (
          <SwiperSlide key={index}>
            <ProductSellingItem data={item} />
          </SwiperSlide>
        ))}
      </Swiper>
      
    </Fragment>
  ) : (
    <></>
  );
}
